import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=5e0117aa&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/bimevents/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e0117aa')) {
      api.createRecord('5e0117aa', component.options)
    } else {
      api.reload('5e0117aa', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=5e0117aa&", function () {
      api.rerender('5e0117aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/Dashboard.vue"
export default component.exports